import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
	standalone: false,
	selector: '[qeBaseIcon]',
})
export class BaseIconDirective {
	@Input() public color: 'primary'|'accent'|'warn' = 'primary';
	@Input('icon-type') public type: 'flat'|'raised'|'ghost'|'minimal' = 'minimal';

	constructor() {

	}

	@HostBinding('class')
	public get iconTheme(): string {
		return `m--${this.color} m--${this.type}`;
	}
}
